import styled from 'styled-components';

import { FlexDiv } from '@shared/components/base/Div';
import { Label } from '@shared/components/base/Text';
import { ColorConstants } from '@shared/constants';
import { ModalHeaderSubtitle } from '@shared/components/texts/ModalHeaderStyles';
import { MobileScreen } from '@shared/components/styles/ConstantMediaQuery';

export const Wrapper = styled(FlexDiv)`
    margin: 25px 0px 25px 0px;
`;

export const SwitchWrapper = styled.div`
    margin-left: 10px;
`;

export const GaugerWrapper = styled.div`
    width: 520px;
    color:#FFF;
`;

export const GaugeLabel = styled(Label)`
    color: ${ColorConstants['catskill-white']};
    padding-top: 8px;
    text-align: right;
    white-space: nowrap;
`;

export const AccordionWrapper = styled.div`
    > div {
        margin: 0.5vh 0;
        
        > *{
            margin-right: 0;
        }
    }
`;

export const InfoWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    padding: 15px;
    transition: all 10s;
    width: 100%;
    color: #3C3655;
    font-weight: 400;
    
    ::-webkit-scrollbar {
        width: 5px;
    }
    
    ::-webkit-scrollbar-track {
        background: transparent;
    }
    
    ::-webkit-scrollbar-thumb {
        background: #d6dadc;
        border-radius: 4px;
    }
    
    ::-webkit-scrollbar-thumb:hover {
        background: #d6dadc;
    }
    
    > div {
        margin: 1vh 0;
        width: 100%;
        
        > *{
        margin-right: 0px;
        }
    }
    > h2 {
        margin-top: 50px;
        text-align: center;
        width: 100%;
    }
`;

export const buttonStyles = {
    'background-image': 'linear-gradient(to right, #3bbbab, #51bba5, '
        + '#61baa1, #6fba9d, #7bb99a)',
    marginTop: '35px',
    width: '100%',
};

export const HeaderSubtitle = styled(ModalHeaderSubtitle)`
    color: ${ColorConstants.white};
    margin: 0;
    max-width: 520px;
    text-align: justify;
    text-justify: inter-word;

    @media ${MobileScreen} { 
        padding: 0px 10px;
    }
`;
